import * as Joi from "joi";

//MM/DD/YYYY
const dateRegex = /^(0?[1-9]|[12]\d|3[01])\/(0?[1-9]|1[0-2])\/(\d{2}|\d{4})$/;

const validateOrderCsv = (orderData, homebaseIds, teamIds) => {
  const order = {
    orderId: Joi.string().required().label("Order ID"),
    teamId: Joi.string()
      .required()
      .valid(...teamIds)
      .label("Team ID"),
    type: Joi.string().required().valid("PICKUP", "DROP").label("Type"),
    orderDate: Joi.string()
      .required()
      .regex(dateRegex)
      .label("Order Date")
      .messages({
        "string.pattern.base": "Order Date must be in DD/MM/YYYY format",
      }),
    homebaseId: Joi.string()
      .required()
      .valid(...homebaseIds)
      .label("Homebase ID"),
    locationId: Joi.string().required().label("Location ID"),
    scContainerCase: Joi.string().label("SCONTAINER-CASE"),
    skuId: Joi.string().required().label("Sku ID"),
    skuCase: Joi.string().label("Case"),
    skuLineItemId: Joi.string().required().label("Sku Line Item ID"),
    skuDetail: Joi.string().required().label("Sku Detail"),
    volume: Joi.number().required().min(0).label("Volume"),
    volumeUnit: Joi.string().required().label("Volume Unit"),
    quantity: Joi.number().required().min(0).label("Quantity"),
    quantityUnit: Joi.string().required().label("Quantity Unit"),
    fullcase: Joi.string().required().label("CUS:FULLCASE"),
    kbox: Joi.string().required().label("CUS:KBOX"),
    tote: Joi.string().required().label("CUS:TOTE"),
    pop: Joi.string().required().label("CUS:POP"),
    totalCase: Joi.string().required().label("CUS:TOTAL-CASE"),
  };
  const schema = Joi.object().keys(order).unknown(true);
  return schema.validate(orderData);
};

export default validateOrderCsv;
